module.exports = __webpack_public_path__ + "img/forum-2017.d961c33b.jpg";